import 'imagemapster';
import 'magnific-popup';

jQuery( document ).ready(function($) {
    
    function reset(){
        console.log('Resized');
        $('img[usemap]').mapster({
            fillOpacity: 0,
            stroke: false,
            onMouseover: function(){
                var target = $(this).attr('href');
                $(target + "-img").addClass('hover');
            },
            onMouseout: function(){
                var target = $(this).attr('href');
                $(target + "-img").removeClass('hover');
            }
        });

        setTimeout(function(){ 
            $('.mapster_el').attr('alt','Roadtrip Map')
        }, 500);
    }

    var timeout = false;
    $(window).on('resize', function(){
        clearTimeout(timeout);
        timeout = setTimeout(reset, 250);
    });

    // $( 'map area' ).on( 'click', function ( e ) {
	// 	e.preventDefault();
	// 	const href = $( this ).attr( 'href' );
	// 	$.magnificPopup.open( {
	// 		items: {
	// 			src: href,
	// 			type: 'inline'
	// 		}
	// 	});
	// });

    $( 'map area' ).on( 'click', function ( e ) {
		e.preventDefault();

        let index = Number($(this).attr('data-count'));

        let items = [];
        $('.popup').each(function() {
            
		    let href = '#' + $( this ).attr( 'id' );
            items.push( {
                src: href,
                type: 'inline'
            } );
        });
        console.log(items)

		$.magnificPopup.open( {
            items: items,
			gallery: {
                enabled: true 
            }
        },index)
	});


    reset();
});